module.exports = __webpack_public_path__ + "img/logo-bca_qris-inactive.3828eb15.svg";